import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { TopupWristband, TopupWristbandPayload } from '../../common/models'

export const getWristbandTopups = (params?: PaginationParams) =>
  http.get<Pagination<TopupWristband>>(`/operations/admin-topup`, { params })

export const createTopup = (data: TopupWristbandPayload) =>
  http.post<{ id: string }>(`/operations/admin-topup`, data)
